//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('componentReplacements', {
//        templateUrl: 'views/components/views/componentReplacements/componentReplacements.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {
//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_componentReplacementsComponentGrid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 3244,
//                    parameters: {}
//                })
//                .setCustomToolbarButtons([{
//                    name: 'new',
//                    text: 'new',
//                    func: () => stateService.go('componentreplacement', { bom_component_replace_keyno: '0' }),
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);
            
//        }]
//    });
//})();
